import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ViewsSliceState {
    payerId?: string;
    segmentId?: string;
}

const initialState: ViewsSliceState = {
    payerId: undefined,
    segmentId: undefined,
};

export const viewsSlice = createSlice({
    name: 'views',
    initialState,
    reducers: {
        setPayerId(state, action: PayloadAction<{ payerId: string | undefined }>) {
            const { payerId } = action.payload;
            return { ...state, payerId, segmentId: undefined };
        },
        setSegmentId(state, action: PayloadAction<{ segmentId: string | undefined }>) {
            const { segmentId } = action.payload;
            return { ...state, segmentId };
        },
    },
});

export const { setPayerId, setSegmentId } = viewsSlice.actions;
